import { useEffect, useState } from 'react';
import { useInfoHintFlash } from '@/stores/info-hint-flash';

/**
 * Returns true for ~2s after each flashAll() call. Used by InfoHint
 * placements to pass a pulsing prop without each call site duplicating
 * subscription logic.
 */
export function useInfoHintPulse(): boolean {
  const counter = useInfoHintFlash((s) => s.counter);
  const [pulsing, setPulsing] = useState(false);
  useEffect(() => {
    if (counter === 0) return;
    setPulsing(true);
    const id = setTimeout(() => setPulsing(false), 2000);
    return () => clearTimeout(id);
  }, [counter]);
  return pulsing;
}
